import cn from 'classnames';
import { ToggleProps } from './types';

const Toggle = ({ onClick, isActive }: ToggleProps) => (
  <button
    onClick={() => onClick()}
    className={cn(
      'z-10 flex h-5 w-10 shrink-0 items-center justify-end rounded-full px-0.5 transition-all duration-150 ease-in-out',
      {
        'bg-[#A5BCB6]': !isActive,
        'bg-[#116A43]': isActive,
      },
    )}
  >
    <div
      className={cn(
        'h-4 w-4 rounded-full bg-white transition-all duration-150 ease-in-out',
        {
          'mr-1 -translate-x-full': !isActive,
        },
      )}
    />
  </button>
);

export default Toggle;
